import NGODonationsLayout from 'features/ngo/donations'
import React from 'react'

const NGODonations = () => {
  return (
    <NGODonationsLayout />
  )
}

export default NGODonations